import script from "./Edit.vue?vue&type=script&setup=true&lang=js"
export * from "./Edit.vue?vue&type=script&setup=true&lang=js"

import "./Edit.vue?vue&type=style&index=0&id=19698cd0&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ignis-pha-production/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19698cd0"]])

export default __exports__